/**
 * Internal dependencies
 */
import { PREFIX_EVENTS_STORE } from '@moderntribe/events/data/utils';

export const SET_DASHBOARD_DATE_TIME = `${ PREFIX_EVENTS_STORE }/SET_DASHBOARD_DATE_TIME`;
export const TOGGLE_DASHBOARD_DATE_TIME = `${ PREFIX_EVENTS_STORE }/TOGGLE_DASHBOARD_DATE_TIME`;

export const SET_DASHBOARD_PRICE = `${ PREFIX_EVENTS_STORE }/SET_DASHBOARD_PRICE`;

export const SET_VISIBLE_MONTH = `${ PREFIX_EVENTS_STORE }/SET_VISIBLE_MONTH`;
